import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import {
  clearIdlingConsumptionMotives,
  getIdlingConsumptionMotives,
} from '../../../../actions';

export const IdlingConsumptionMotiveSelect = ({
  loading,
  idlingConsumptionMotiveOptions,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchGetIdlingConsumptionMotives,
  dispatchClearIdlingConsumptionMotives,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearIdlingConsumptionMotives(), []);

  const onInputChangeMotive = (inputValue) => {
    const inputValueLength = inputValue.trim().length;
    if (inputValueLength > 4) {
      const query = [];

      if (inputValueLength && inputValueLength >= 4)
        query.push(`description:${inputValue}`);

      dispatchGetIdlingConsumptionMotives({
        ...DEFAULT_QUERY_GET_ALL,
        query,
      });
    }
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChangeMotive}
      options={idlingConsumptionMotiveOptions}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

IdlingConsumptionMotiveSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchClearIdlingConsumptionMotives: PropTypes.func.isRequired,
  dispatchGetIdlingConsumptionMotives: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  idlingConsumptionMotiveOptions: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

IdlingConsumptionMotiveSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  idlingConsumptionMotiveOptions: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca por nombre',
};

const mapStateToProps = ({ TrafficUnit }) => {
  const idlingConsumptionMotiveOptions = TrafficUnit.IdlingConsumption.getIn([
    'motives',
    'content',
    'content',
  ]).map((consumptionMotive) => ({
    value: consumptionMotive.id,
    label: consumptionMotive.description,
  }));

  return {
    idlingConsumptionMotiveOptions,
    loading: TrafficUnit.IdlingConsumption.getIn(['motives', 'loading']),
  };
};
const mapDispatchToProps = {
  dispatchGetIdlingConsumptionMotives: getIdlingConsumptionMotives,
  dispatchClearIdlingConsumptionMotives: clearIdlingConsumptionMotives,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IdlingConsumptionMotiveSelect);
